import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

const COLORS = [
  "#00008B",
  "#FFBF00",
  "#228B22",
  "#8B0000",
  "#A3008B",
  "#00A395",
  "#A30003",
  "#FFC300",
  "#008B8B",
  "#6A0DAD",
  "#228B22",
];

const LoanTenure = ({ tenureStatistics }) => {
  const tenure =
    tenureStatistics?.map((item) => ({
      ...item,
      tenure: Number(item.tenure),
    })) || [];

  return (
    <ResponsiveContainer width="98%" height="100%">
      <BarChart
        data={tenure}
        layout="horizontal"
        margin={{ top: 20, right: 5, left: 5, bottom: 20 }}
      >
        <XAxis
          type="category"
          dataKey="name"
          axisLine={{ stroke: "#000", strokeWidth: 1 }}
          tick={{ fontSize: 12 }}
          label={{
            value: "Loan Products",
            angle: 0,
            position: "insideBottom",
            offset: -10,
            style: { textAnchor: "middle", fontSize: "14" },
          }}
          tickFormatter={(name) =>
            name
              .split(" ")
              .map((word) => word[0])
              .join("")
              .toUpperCase()
          }
        />
        <YAxis
          type="number"
          axisLine={true}
          tickLine={true}
          domain={[0, "dataMax + 6"]}
          label={{
            value: "Number of loans",
            angle: -90,
            position: "insideLeft",
            offset: 20,
            style: { textAnchor: "middle", fontSize: 14 },
          }}
        />
        <Tooltip cursor={false} />
        <Bar dataKey="tenure" radius={[10, 10, 0, 0]}>
          {tenure.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default LoanTenure;
